import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringify',
    standalone: false
})
export class StringifyPipe implements PipeTransform {
  transform(value: any): string {
    return JSON.stringify(value);
  }
}
